import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './UserLogs.css';

function UserLogs({ tableData }) {
    return (
        <div className="user_logs-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No hay logs para este usuario</h4>
            )}
        </div>
    );
}

export default UserLogs;
